import { IHttpApi } from '@cian/http-api';
import { fetchSendTimer } from '../repositories/browser-telemetry/v1/send-timer';
import { fetchSendIncrement } from '../repositories/browser-telemetry/v1/send-increment';

export interface ISendTelemetryTimer {
  httpApi: IHttpApi;
  key: string;
  value: number;
}

export const sendTelemetryTimer = ({ httpApi, key, value }: ISendTelemetryTimer) => {
  try {
    fetchSendTimer({
      httpApi,
      parameters: { key, value },
    });
    /* istanbul ignore next */
  } catch (e) {
    // Ничего не логируем
  }
};

export interface ISendTelemetryCounter {
  httpApi: IHttpApi;
  key: string;
  value?: number;
}

export const sendTelemetryCounter = ({ httpApi, key, value }: ISendTelemetryCounter) => {
  try {
    fetchSendIncrement({
      httpApi,
      parameters: { key, value },
    });
    /* istanbul ignore next */
  } catch (e) {
    // Ничего не логируем
  }
};
